const TOKEN_KEY = 'token';

export const getTokenFromStorage = () => localStorage.getItem(TOKEN_KEY);
export const setTokenToStorage = (token) => localStorage.setItem(TOKEN_KEY, token);
export const removeTokenFromStorage = () => localStorage.removeItem(TOKEN_KEY);
